<template>
    <v-app>
        <ConfirmDialog ref="confirmdialog" />
        <TopBar v-if="$vuetify.breakpoint.mdAndUp" />
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<style lang="scss">
  @import './styles/variables.scss';
</style>


<script>
import TopBar from "@/components/navigation/TopBar";
import ConfirmDialog from "@/support/modals/ConfirmDialog";


export default {
    name: 'App',

    components: {
        TopBar,
        ConfirmDialog,
    },

    mounted() {
        this.$root.$confirmdialog = this.$refs.confirmdialog.open;
    },

    data: () => ({
        //
    }),
};
</script>
